import React, { useState } from 'react';
import { AiFillRightSquare } from 'react-icons/ai';
import classes from './SendLoadToBBIButton.module.css';
import TransportationCaller from '../../api/internal/TransportationCaller';
import Create from '../error/Create';
import Error from '../../helpers/error/Error';
import Select from '../../assets/essentials/Select';

type SendDestination = 'wildcat' | 'waas';

/**
SendLoadToBBIButton component for sending a load to BBI's TMS.
This component renders a destination selector and a button that, when clicked, sends the load to the chosen TMS (legacy Wildcat or WaaS). It also handles error states and provides a callback function to refresh the page after sending the load.
@param {string} loadId - The ID of the load to send.
@param {boolean} isDisabled - Determines if the control is disabled.
@param {Function} RefreshPage - A callback function to refresh the page after sending the load.
@param {string} pageToRefresh - The page to refresh after sending the load.
@param {string[]} pageArrayToRefresh - An array of pages to refresh after sending the load.
@returns {JSX.Element} - The SendLoadToBBIButton component.
@example
// Example usage of SendLoadToBBIButton component:
<SendLoadToBBIButton
loadId="123"
isDisabled={false}
RefreshPage={RefreshPage}
pageToRefresh={'Summary'}
pageArrayToRefresh={['Financials', 'Audit']}
/> */

export default function SendLoadToBBIButton({
  loadId,
  isDisabled,
  RefreshPage,
  pageToRefresh,
  pageArrayToRefresh,
}: {
  loadId: number;
  isDisabled: boolean;
  RefreshPage: Function;
  pageToRefresh: string;
  pageArrayToRefresh: string[];
}) {
  const [destination, setDestination] = useState<SendDestination>('waas');

  const HandleSendLoad = () => {
    const endpoint =
      destination === 'waas'
        ? `/Load/SendLoadToWaas/${loadId}`
        : `/Load/SendLoadToBBI/${loadId}`;
    TransportationCaller.post(endpoint)
      .then(response => {
        if (response) {
          RefreshPage(pageToRefresh, pageArrayToRefresh);
        }
      })
      .catch(error => {
        Create(<Error error={error} />);
      });
  };
  return (
    <div className={classes.container}>
      {/* Destination selector hidden for now — WaaS (Wildcat 2.0) is the
          default. Uncomment to let users pick the destination again. */}
      {/* <Select
        value={destination}
        onChange={e => setDestination(e.target.value as SendDestination)}
        disabled={isDisabled}
      >
        <option value="wildcat">Wildcat 1.0</option>
        <option value="waas">Wildcat 2.0</option>
      </Select> */}
      <button
        onClick={HandleSendLoad}
        disabled={isDisabled}
        className={classes.button}
      >
        <AiFillRightSquare />
        Send Load to BBI
      </button>
    </div>
  );
}
